import { isEmpty } from "lodash";

import { Space } from "../../data";

/**
 * Whether a space's price can differ from one date to the next, and so is worth
 * showing per-day in the calendar.
 *
 * The day-rates payload prices every requested date, including dates at the
 * rack rate, so an empty response no longer means "this space has no dynamic
 * pricing" — only the space's own configuration answers that.
 */
export function spaceAdvertisesVaryingPrices(space?: Space | null): boolean {
  const hasDynamicRates = !isEmpty(space?.dynamicPriceRates);
  const hasSmartPricing = !!(
    space?.smartPricingEnabled && space?.smartPricingSupported
  );

  return hasDynamicRates || hasSmartPricing;
}
